/**
 * Created by mark on 17/12/2017.
 */
import Constants from '../constants.js';
class LicenceStore {

    constructor(){
        this.braintreeCode = false;
        this.packages = {};
        this.actions = {};
    }

    setExtraValue(id , index , value){
        this.packages[id].licence[index].number = value
    }

    get(id) {
        return this.packages[id] || false;
    }

    import(action, response) {
        switch (action) {
          case Constants.ON_GOT_LICENCE:
              this.licence = response || [];
              this.packages[0] = response;
              this.trigger(action);
              break;
          case Constants.GOT_BRAINTREE_CODE:
              this.braintreeCode = response.code;
              this.trigger(action);
              break;
          default:
              break;
        }
    }

    once(action, response) {
        if (this.actions[action] == undefined) {
            this.actions[action] = [];
        }
        this.actions[action].push(response);
    }

    trigger(action) {
        if (this.actions[action] != undefined) {
            for (var  i =0; i <this.actions[action].length; i++ ) {
                this.actions[action][i]();
            }
        }
    }
}

let exportClass = new LicenceStore();
export default exportClass;